
import { CustomButtom } from '../common/CustomButton/CustomButton';
import s from './profile.module.scss';
import r from '../Authentification/auth.module.scss';
import classnames from 'classnames';
import { FC, MutableRefObject, useEffect, useRef, useState } from "react";
import { StatusMenu } from '../common/StatusMenu/StatusMenu';
import { message } from 'antd';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { MeSlice, getMe } from '../../store/slice/meSlice';
import { GetRelatedUsers, IRelatedUser, getRelatedUsers } from '../../store/slice/getRelatedUsers';
import { Image } from 'antd/lib';
import { setProfileEdit, setSubUser } from '../../store/slice/staticSlice';
import { CustomInput } from '../common/CustomInput/CustomInput';
import { LockIcon } from '../../icons/lock-icon';
import { createRelated } from '../../store/slice/registerRelatedSlice';
import { PersonallyImg } from '../../icons/personally-img';
import { ChildrenImg } from '../../icons/childern-img';
import { TeacherImg } from '../../icons/tescher-img';
import { updateRelated } from '../../store/slice/updateRelated';
import { setPhoto } from '../../store/slice/setUserPhotoSlice';
import { setRelatedPhoto } from '../../store/slice/setRelatedPhotoSlice';
import { UserIcon } from '../../icons/user-icon';
import { PhotoIcon } from '../../icons/photo-icon';
import { switchUser } from '../../store/slice/tokenSlice';

const cn = classnames.bind(this)

interface IAddProfile {
    handleTitle: (title: string) => void
    setStatus: (status: boolean) => void
    setRewardStatus: (status: boolean) => void
}

export const AddProfile: FC<IAddProfile> = ({ handleTitle, setStatus, setRewardStatus }) => {
    const { data: meData } = useAppSelector(MeSlice)
    const {loading:rLoading, data: rData } = useAppSelector(GetRelatedUsers)
    const dispatch = useAppDispatch()
    const [step, setStep] = useState(1)
    const [wnd, setWnd] = useState(1)
    const items = ["Логин", "Пароль", "Для кого", "Профиль", "done"]
    const [status, setStatus1] = useState<string>("Логин")
    // const [useerName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [userName, setUserName] = useState("")
    const [newUserId, setNewUserId] = useState('')
    const [error, setError] = useState('')
    const [pError, setPerror] = useState('')

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const doSwitchUser = (userId:string) => {
        dispatch(switchUser({
            token: localStorage.getItem('access'),
            id: userId
        })).then((resp:any)=>{
            if(!resp.error){
                dispatch(getMe({token: resp.payload.access}))
                setStatus(false)
            }
        })
    }

    const doSwitchUserAdd = (userId:string) => {
        dispatch(switchUser({
            token: localStorage.getItem('access'),
            id: userId
        })).then((resp:any)=>{
            if(!resp.error){
                dispatch(getMe({token: resp.payload.access})).then((res:any)=>{
                    if(!res.error){
                        setRewardStatus(true)
                        setStatus(false)
                    }
                })
            }
        })
    }


    const nextClick = () => {
        setError('')
        setPerror('')
        if (step === 1) {
            setStep(step + 1)
        }
        if (step === 2) {
            dispatch(createRelated({
                token: localStorage.getItem('access'),
                username: userName,
                password: password
            })).then((resp: any) => {
                if (resp.error) {
                    if (!!resp.payload.data.username) {
                        setError('Этот логин уже зарегистрирован на сервисе')
                    }
                    if (!!resp.payload.data.password) {
                        setError(resp.payload.data.password)
                    }
                    setStep(1)
                }
                if (!resp.error) {
                    setNewUserId(resp.payload.id)
                    setStep(step + 1)
                    dispatch(getRelatedUsers({ token: localStorage.getItem('access') }))
                    // dispatch(getMe({ token: resp.payload.tokens.access }))
                }
            })
        }
        if (step === 3) {
            setStep(step + 1)
        }
        if (step === 4) {
            setStep(step + 1)
        }

    }

    useEffect(() => {
        dispatch(getRelatedUsers({ token: localStorage.getItem('access') }))
    }, [])

    useEffect(() => {
        step === 1 && setStatus1('Логин')
        step === 2 && setStatus1('Пароль')
        step === 3 && setStatus1('Для кого')
        step === 4 && setStatus1('Профиль')
        step === 5 && setStatus1('done')
    }, [step])

    useEffect(() => {
        wnd === 1 && handleTitle('Добавить профиль')
        wnd === 2 && handleTitle('Добавление профиля')
    }, [wnd])

    return (<>
        {wnd === 1 && <div className={s.profileUserPlans}>
            <div className={s.profileUserPlansList}>
                <div className={s.userProfilePlan}>
                    {!!meData.profile.image ?
                        <img className={s.userProfilePlanImage} src={meData.profile.image} width={32} height={32} alt="" /> :
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 8C14.4178 8 12.871 8.46919 11.5554 9.34824C10.2398 10.2273 9.21447 11.4767 8.60897 12.9385C8.00347 14.4003 7.84504 16.0089 8.15372 17.5607C8.4624 19.1126 9.22433 20.538 10.3431 21.6568C11.462 22.7757 12.8874 23.5376 14.4393 23.8463C15.9911 24.155 17.5997 23.9965 19.0615 23.391C20.5233 22.7855 21.7727 21.7601 22.6518 20.4446C23.5308 19.129 24 17.5822 24 16C23.9978 13.879 23.1542 11.8454 21.6544 10.3456C20.1546 8.84581 18.121 8.00224 16 8ZM11.8523 21.3461C12.2975 20.6499 12.9108 20.0769 13.6356 19.68C14.3605 19.2831 15.1736 19.0751 16 19.0751C16.8264 19.0751 17.6395 19.2831 18.3644 19.68C19.0892 20.0769 19.7025 20.6499 20.1477 21.3461C18.9618 22.2684 17.5023 22.7692 16 22.7692C14.4977 22.7692 13.0382 22.2684 11.8523 21.3461ZM13.5385 15.3846C13.5385 14.8978 13.6828 14.4219 13.9533 14.0171C14.2238 13.6123 14.6082 13.2968 15.058 13.1104C15.5078 12.9241 16.0027 12.8754 16.4802 12.9704C16.9577 13.0654 17.3963 13.2998 17.7406 13.644C18.0848 13.9883 18.3193 14.4269 18.4142 14.9044C18.5092 15.3819 18.4605 15.8768 18.2742 16.3266C18.0879 16.7764 17.7724 17.1608 17.3676 17.4313C16.9628 17.7018 16.4868 17.8461 16 17.8461C15.3472 17.8461 14.7211 17.5868 14.2594 17.1252C13.7978 16.6636 13.5385 16.0375 13.5385 15.3846ZM21.0585 20.4931C20.3721 19.4985 19.4071 18.7291 18.2846 18.2815C18.8876 17.8066 19.3275 17.1557 19.5433 16.4191C19.7591 15.6826 19.7401 14.8971 19.4888 14.172C19.2375 13.4468 18.7664 12.8179 18.1412 12.3728C17.5159 11.9278 16.7675 11.6886 16 11.6886C15.2325 11.6886 14.4841 11.9278 13.8588 12.3728C13.2336 12.8179 12.7625 13.4468 12.5112 14.172C12.2599 14.8971 12.2409 15.6826 12.4567 16.4191C12.6725 17.1557 13.1125 17.8066 13.7154 18.2815C12.5929 18.7291 11.6279 19.4985 10.9415 20.4931C10.0743 19.5178 9.50744 18.3126 9.30927 17.0227C9.11109 15.7327 9.29004 14.413 9.82455 13.2224C10.3591 12.0318 11.2264 11.0211 12.322 10.312C13.4176 9.60284 14.6949 9.22557 16 9.22557C17.3051 9.22557 18.5824 9.60284 19.678 10.312C20.7736 11.0211 21.6409 12.0318 22.1754 13.2224C22.71 14.413 22.8889 15.7327 22.6907 17.0227C22.4926 18.3126 21.9257 19.5178 21.0585 20.4931Z" fill="#E9E9E9" />
                            <rect x="0.163265" y="0.163265" width="31.6735" height="31.6735" rx="15.8367" stroke="#DDBE90" strokeWidth="0.326531" />
                        </svg>
                    }
                    <div className={s.userProfilePlanName}>{meData.profile.full_name}</div>
                    <div onClick={() => {
                        dispatch(setProfileEdit(true))
                        setStatus(false)
                    }} className={s.userProfilePlanEdit}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 18.7143H20V19.8571H4V18.7143ZM17.3714 9C17.8286 8.54286 17.8286 7.85714 17.3714 7.4L15.3143 5.34286C14.8571 4.88571 14.1714 4.88571 13.7143 5.34286L5.14286 13.9143L5.14286 17.5714H8.8L17.3714 9ZM14.5143 6.14286L16.5714 8.2L14.8571 9.91429L12.8 7.85714L14.5143 6.14286ZM6.28571 16.4286V14.3714L12 8.65714L14.0571 10.7143L8.34286 16.4286H6.28571Z" fill="#818181" />
                        </svg>
                    </div>
                </div>
                <div className={s.userProfileSeparator}></div>
                {!rLoading && rData.length === 0 && <>
                    <div className={s.addProfileBLock}>
                        <div className={s.addProfileText}>
                            Добавьте в подписку близкого или дополнительный профиль для себя
                        </div>
                        <CustomButtom onClick={() => { setWnd(2) }} type='secondary'>
                            Добавить <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.9999 11.9144H12.4166V16.4977C12.4166 16.7408 12.32 16.974 12.1481 17.1459C11.9762 17.3178 11.743 17.4144 11.4999 17.4144C11.2568 17.4144 11.0236 17.3178 10.8517 17.1459C10.6798 16.974 10.5833 16.7408 10.5833 16.4977V11.9144H5.99992C5.7568 11.9144 5.52365 11.8178 5.35174 11.6459C5.17983 11.474 5.08325 11.2408 5.08325 10.9977C5.08325 10.7546 5.17983 10.5214 5.35174 10.3495C5.52365 10.1776 5.7568 10.0811 5.99992 10.0811H10.5833V5.49772C10.5833 5.25461 10.6798 5.02145 10.8517 4.84954C11.0236 4.67763 11.2568 4.58105 11.4999 4.58105C11.743 4.58105 11.9762 4.67763 12.1481 4.84954C12.32 5.02145 12.4166 5.25461 12.4166 5.49772V10.0811H16.9999C17.243 10.0811 17.4762 10.1776 17.6481 10.3495C17.82 10.5214 17.9166 10.7546 17.9166 10.9977C17.9166 11.2408 17.82 11.474 17.6481 11.6459C17.4762 11.8178 17.243 11.9144 16.9999 11.9144Z" fill="#DDBE90" />
                            </svg>

                        </CustomButtom>
                    </div>
                </>}
                {!rLoading && rData.length > 0 && rData.map((pr: IRelatedUser, i: number) => {
                    return (
                        <div key={i}>
                            <div className={s.userProfilePlan}>
                                {!!pr.profile.image ?
                                    <img className={s.userProfilePlanImage} src={pr.profile.image} width={32} height={32} alt="" /> :
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16 8C14.4178 8 12.871 8.46919 11.5554 9.34824C10.2398 10.2273 9.21447 11.4767 8.60897 12.9385C8.00347 14.4003 7.84504 16.0089 8.15372 17.5607C8.4624 19.1126 9.22433 20.538 10.3431 21.6568C11.462 22.7757 12.8874 23.5376 14.4393 23.8463C15.9911 24.155 17.5997 23.9965 19.0615 23.391C20.5233 22.7855 21.7727 21.7601 22.6518 20.4446C23.5308 19.129 24 17.5822 24 16C23.9978 13.879 23.1542 11.8454 21.6544 10.3456C20.1546 8.84581 18.121 8.00224 16 8ZM11.8523 21.3461C12.2975 20.6499 12.9108 20.0769 13.6356 19.68C14.3605 19.2831 15.1736 19.0751 16 19.0751C16.8264 19.0751 17.6395 19.2831 18.3644 19.68C19.0892 20.0769 19.7025 20.6499 20.1477 21.3461C18.9618 22.2684 17.5023 22.7692 16 22.7692C14.4977 22.7692 13.0382 22.2684 11.8523 21.3461ZM13.5385 15.3846C13.5385 14.8978 13.6828 14.4219 13.9533 14.0171C14.2238 13.6123 14.6082 13.2968 15.058 13.1104C15.5078 12.9241 16.0027 12.8754 16.4802 12.9704C16.9577 13.0654 17.3963 13.2998 17.7406 13.644C18.0848 13.9883 18.3193 14.4269 18.4142 14.9044C18.5092 15.3819 18.4605 15.8768 18.2742 16.3266C18.0879 16.7764 17.7724 17.1608 17.3676 17.4313C16.9628 17.7018 16.4868 17.8461 16 17.8461C15.3472 17.8461 14.7211 17.5868 14.2594 17.1252C13.7978 16.6636 13.5385 16.0375 13.5385 15.3846ZM21.0585 20.4931C20.3721 19.4985 19.4071 18.7291 18.2846 18.2815C18.8876 17.8066 19.3275 17.1557 19.5433 16.4191C19.7591 15.6826 19.7401 14.8971 19.4888 14.172C19.2375 13.4468 18.7664 12.8179 18.1412 12.3728C17.5159 11.9278 16.7675 11.6886 16 11.6886C15.2325 11.6886 14.4841 11.9278 13.8588 12.3728C13.2336 12.8179 12.7625 13.4468 12.5112 14.172C12.2599 14.8971 12.2409 15.6826 12.4567 16.4191C12.6725 17.1557 13.1125 17.8066 13.7154 18.2815C12.5929 18.7291 11.6279 19.4985 10.9415 20.4931C10.0743 19.5178 9.50744 18.3126 9.30927 17.0227C9.11109 15.7327 9.29004 14.413 9.82455 13.2224C10.3591 12.0318 11.2264 11.0211 12.322 10.312C13.4176 9.60284 14.6949 9.22557 16 9.22557C17.3051 9.22557 18.5824 9.60284 19.678 10.312C20.7736 11.0211 21.6409 12.0318 22.1754 13.2224C22.71 14.413 22.8889 15.7327 22.6907 17.0227C22.4926 18.3126 21.9257 19.5178 21.0585 20.4931Z" fill="#E9E9E9" />
                                        <rect x="0.163265" y="0.163265" width="31.6735" height="31.6735" rx="15.8367" stroke="#DDBE90" strokeWidth="0.326531" />
                                    </svg>
                                }
                                <div onClick={() => {
                                    doSwitchUser(pr.id)
                                    setStatus(false)
                                }} className={s.userProfilePlanName}>{!!pr.profile.full_name ? pr.profile.full_name : pr.username}</div>
                                <div onClick={() => {
                                    dispatch(setSubUser(true))
                                    dispatch(setProfileEdit(true))
                                    setStatus(false)
                                }} className={s.userProfilePlanEdit}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 18.7143H20V19.8571H4V18.7143ZM17.3714 9C17.8286 8.54286 17.8286 7.85714 17.3714 7.4L15.3143 5.34286C14.8571 4.88571 14.1714 4.88571 13.7143 5.34286L5.14286 13.9143L5.14286 17.5714H8.8L17.3714 9ZM14.5143 6.14286L16.5714 8.2L14.8571 9.91429L12.8 7.85714L14.5143 6.14286ZM6.28571 16.4286V14.3714L12 8.65714L14.0571 10.7143L8.34286 16.4286H6.28571Z" fill="#818181" />
                                    </svg>
                                </div>
                            </div>
                            <div className={s.userProfileSeparator}></div>
                        </div>
                    )
                })}
            </div>
        </div>}
        {wnd === 2 && <>
            <div className={s.registerWrapper}>
                {step !== 5 && <>
                    <div className={r.statusMenu}>
                        <StatusMenu
                            items={items}
                            current={status}
                        />
                    </div>
                </>
                }
                {step === 1 &&
                    <div className={s.registrationSteps}>
                        <div className={r.stepBody}>
                            <CustomInput
                                name="email"
                                icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 4C10.4178 4 8.87103 4.46919 7.55544 5.34824C6.23985 6.22729 5.21447 7.47672 4.60897 8.93853C4.00347 10.4003 3.84504 12.0089 4.15372 13.5607C4.4624 15.1126 5.22433 16.538 6.34315 17.6568C7.46197 18.7757 8.88743 19.5376 10.4393 19.8463C11.9911 20.155 13.5997 19.9965 15.0615 19.391C16.5233 18.7855 17.7727 17.7601 18.6518 16.4446C19.5308 15.129 20 13.5822 20 12C19.9978 9.87895 19.1542 7.84542 17.6544 6.34562C16.1546 4.84581 14.121 4.00224 12 4ZM7.85231 17.3461C8.29749 16.6499 8.91078 16.0769 9.63563 15.68C10.3605 15.2831 11.1736 15.0751 12 15.0751C12.8264 15.0751 13.6395 15.2831 14.3644 15.68C15.0892 16.0769 15.7025 16.6499 16.1477 17.3461C14.9618 18.2684 13.5023 18.7692 12 18.7692C10.4977 18.7692 9.03821 18.2684 7.85231 17.3461ZM9.53846 11.3846C9.53846 10.8978 9.68283 10.4219 9.95331 10.0171C10.2238 9.61226 10.6082 9.29676 11.058 9.11045C11.5078 8.92414 12.0027 8.87539 12.4802 8.97037C12.9577 9.06535 13.3963 9.29979 13.7406 9.64404C14.0848 9.98829 14.3193 10.4269 14.4142 10.9044C14.5092 11.3819 14.4605 11.8768 14.2742 12.3266C14.0879 12.7764 13.7724 13.1608 13.3676 13.4313C12.9628 13.7018 12.4868 13.8461 12 13.8461C11.3472 13.8461 10.7211 13.5868 10.2594 13.1252C9.7978 12.6636 9.53846 12.0375 9.53846 11.3846ZM17.0585 16.4931C16.3721 15.4985 15.4071 14.7291 14.2846 14.2815C14.8876 13.8066 15.3275 13.1557 15.5433 12.4191C15.7591 11.6826 15.7401 10.8971 15.4888 10.172C15.2375 9.44677 14.7664 8.81791 14.1412 8.37284C13.5159 7.92776 12.7675 7.6886 12 7.6886C11.2325 7.6886 10.4841 7.92776 9.85882 8.37284C9.23355 8.81791 8.76252 9.44677 8.51122 10.172C8.25993 10.8971 8.24086 11.6826 8.45667 12.4191C8.67249 13.1557 9.11245 13.8066 9.71539 14.2815C8.59294 14.7291 7.62787 15.4985 6.94154 16.4931C6.07429 15.5178 5.50744 14.3126 5.30927 13.0227C5.11109 11.7327 5.29004 10.413 5.82455 9.22238C6.35907 8.03177 7.22637 7.02106 8.32201 6.31195C9.41764 5.60284 10.6949 5.22557 12 5.22557C13.3051 5.22557 14.5824 5.60284 15.678 6.31195C16.7736 7.02106 17.6409 8.03177 18.1754 9.22238C18.71 10.413 18.8889 11.7327 18.6907 13.0227C18.4926 14.3126 17.9257 15.5178 17.0585 16.4931Z" fill="#DDBE90" />
                                </svg>
                                }
                                type="email"
                                onChange={(e) => {
                                    setUserName(e.target.value)
                                }}
                                placeholder='Укажите логин'
                            />
                            {!!error && <div className="form-error" style={{ marginBottom: '16px' }}>{error}</div>}
                        </div>
                    </div>
                }
                {step === 2 &&
                    <div className={s.registrationSteps}>
                        <div className={r.stepBody}>
                            <CustomInput
                                name="password"
                                icon={<LockIcon />}
                                type="password"
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder='Укажите пароль'
                            />
                            {!!pError && <div className="form-error" style={{ marginBottom: '16px' }}>{pError}</div>}
                        </div>
                    </div>}
                {step === 3 && <div className={s.registrationSteps}>
                    <div className={r.stepBody}>
                        <AddCategories id={newUserId} />
                    </div>

                </div>}
                {step === 4 && <div className={s.registrationSteps}>
                    <div className={r.stepBody}>
                        <RefativeProfile id={newUserId} />
                    </div>
                </div>}
                {step === 5 &&
                    <div className={r.registrationStep5}>
                        <div className={r.stepBody}>
                            <div className={s.relatedSuccess}>
                            <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M47.2285 24.8571C47.0088 24.6638 46.737 24.5407 46.4478 24.5035C46.1585 24.4662 45.8648 24.5165 45.604 24.6479L38.0263 28.4581L31.7633 17.9602C31.632 17.7402 31.4464 17.5583 31.2248 17.432C31.0031 17.3056 30.7528 17.2393 30.4982 17.2393C30.2436 17.2393 29.9933 17.3056 29.7716 17.432C29.55 17.5583 29.3644 17.7402 29.2331 17.9602L22.9702 28.4581L15.3954 24.6494C15.1346 24.5181 14.841 24.4676 14.5518 24.5043C14.2626 24.5411 13.9907 24.6634 13.7703 24.8558C13.55 25.0483 13.3911 25.3022 13.3137 25.5857C13.2363 25.8691 13.2439 26.1693 13.3355 26.4484L18.7408 43.1507C18.7815 43.2768 18.8498 43.392 18.9407 43.4878C19.0315 43.5837 19.1426 43.6577 19.2656 43.7044C19.3886 43.7511 19.5205 43.7692 19.6514 43.7576C19.7824 43.7459 19.909 43.7047 20.022 43.637C20.0323 43.637 20.9804 43.0712 22.7393 42.5201C24.3624 42.0103 27.0227 41.4033 30.4982 41.4033C33.9737 41.4033 36.634 42.0103 38.2585 42.5201C40.0116 43.0712 40.9656 43.6311 40.9729 43.6355C41.0859 43.7035 41.2126 43.745 41.3436 43.7569C41.4746 43.7688 41.6066 43.7508 41.7299 43.7043C41.8531 43.6577 41.9643 43.5838 42.0553 43.488C42.1463 43.3921 42.2148 43.2769 42.2556 43.1507L47.6609 26.4513C47.7551 26.1725 47.7643 25.8715 47.6872 25.5873C47.6101 25.3031 47.4504 25.0488 47.2285 24.8571ZM40.9042 41.6287C39.2972 40.9038 35.7326 39.6352 30.4982 39.6352C25.2638 39.6352 21.6992 40.9038 20.0922 41.6287L15.2054 26.5294L22.415 30.154C22.7479 30.3194 23.13 30.3532 23.4864 30.2488C23.8427 30.1444 24.1474 29.9092 24.3405 29.5897L30.4982 19.2759L36.6559 29.597C36.849 29.9162 37.1534 30.1511 37.5094 30.2555C37.8654 30.3599 38.2472 30.3263 38.5799 30.1613L45.791 26.5353L40.9042 41.6287Z" fill="#DDBE90"/>
<rect x="0.5" y="0.5" width="60" height="60" rx="30" stroke="#DDBE90"/>
</svg>

                            <div className={s.relatedSuccessTItle}>Добавление профиля прошло успешно!</div>
                            </div>
                        </div>
                    </div>}
                <div className={s.stepsFooter}>

                    {step !== 5 && step !==3 &&
                        <div className={r.stepButton}>
                            {step > 1 && <CustomButtom
                                onClick={() => {
                                    setStep(step - 1)
                                }}
                                type='secondary'
                            >Назад
                            </CustomButtom>
                            }
                            <CustomButtom
                                disabled={step === 1 && !userName}
                                onClick={()=>{
                                    if (step === 2){
                                        /^.{8,}$/.test(password) ? nextClick() : setPerror("Пароль должен содержать минимум 8 символов")
                                    } else {
                                        nextClick()
                                    }
                                }}
                                type='primary'
                            >Дальше
                            </CustomButtom>
                        </div>
                    }
                     {step === 3 &&
                        <div className={r.stepButton}>
                           <CustomButtom
                                onClick={() => {
                                    setStep(step + 1)
                                }}
                                type='secondary'
                            >Пропустить
                            </CustomButtom>
                            <CustomButtom
                                onClick={nextClick}
                                type='primary'
                            >Дальше
                            </CustomButtom>
                        </div>
                    }
                    {step === 5 &&
                        <div className={s.stepButton}>
                            <CustomButtom
                                onClick={() => { doSwitchUserAdd(newUserId) }}
                                type='primary'
                            > Добавить награду
                            </CustomButtom>
                            <CustomButtom
                                onClick={() => { doSwitchUser(newUserId) }}
                                type='secondary'
                            > Перейти в профиль
                            </CustomButtom>
                        </div>
                    }
                </div>
            </div>
        </>}
    </>)
}

interface IRegisterCategories {
    id: string
}

const AddCategories: FC<IRegisterCategories> = ({ id }) => {
    const dispatch = useAppDispatch()

    const onCategoryChange = (data: any) => {
        const _token = localStorage.getItem("access")
        _token && _token !== null && id && dispatch(updateRelated({
            token: localStorage.getItem("access"),
            id: id,
            data: {
                category: data.target.value
            }
        }))
    }

    return (<>
        <div className={s.categoryLabels}>
            <label className={s.categoryLabel}>
                <PersonallyImg />
                <span className={s.categoryTitle}>Персонально</span>
                <input className={s.categoryInput} style={{ display: "none" }} onChange={onCategoryChange} type="radio" name="category[]" value="personally" />
                <span></span>
            </label>
            <label className={s.categoryLabel}>
                <ChildrenImg />
                <span className={s.categoryTitle}>Детям</span>
                <input className={s.categoryInput} style={{ display: "none" }} onChange={onCategoryChange} type="radio" name="category[]" value="children" />
                <span></span>
            </label>
            <label className={s.categoryLabel}>
                <TeacherImg />
                <span className={s.categoryTitle}>Я тренер / педагог</span>
                <input className={s.categoryInput} style={{ display: "none" }} onChange={onCategoryChange} type="radio" name="category[]" value="teacher" />
                <span></span>
            </label>
        </div>
    </>)
}

interface IRegisterProfile {
    id: string
}

export const RefativeProfile: FC<IRegisterProfile> = ({ id }) => {
    const inputFile = useRef() as MutableRefObject<HTMLInputElement>
    const [filename, setFileName] = useState<null | string>(null)
    const dispatch = useAppDispatch()

    const clickHandler = (e: any) => {
        e.preventDefault()
        const files = Array.prototype.slice.call(inputFile.current.files);
        const formData = new FormData();
        formData.append('file', files[0]);
        const token = localStorage.getItem('access');
        dispatch(setRelatedPhoto({
            token: token,
            id: id,
            data: formData
        })).then((resp: any) => {
            if (!resp.error) {
                setFileName(resp.payload.image)
            }
        })
    }

    return (<>
        <div className={s.profileForm}>
            <div className={s.profileAvatar}>
                {filename !== null ? <img style={{minWidth: 150}} className={s.userAvatar} width={150} height={150} alt="" src={filename} /> : <UserIcon size={28} fill="#E9E9E9" />}
            </div>
            <input onChange={e => { clickHandler(e) }} type='file' id='file' ref={inputFile} style={{ display: 'none' }} />
            <CustomButtom
                onClick={() => {
                    inputFile.current.click();
                }}
                type='secondary'
            ><PhotoIcon /> Загрузить фотографию
            </CustomButtom>
        </div>
    </>)
}
